<div class="panel-body ">
  <div class="col-md-12 panel panel-default panel-margin-bottom panel-margin-top">
   <div class="panel-body">
     <div class="row">
      <div class="table-responsive" [class.scroll-hide-xy]="(civilCase.getTranscriptList().length==0)" >
        <table id="transcript-table" class="table table-condensed table-striped">
          <thead>
            <tr>
              <th>
                <span class="field-code">V189c V230c json='docketBookNum#', 'docketBookNum', 'docketPageNum', 'abstractCode', 'abstractNumber'</span> 
                 <span id="V189">Abstract</span>
              </th>
              <th>
                <span class="field-code">V357 json='transcriptOn'</span> 
                <span id="V357">Date and Time of Transcript</span>
              </th>
              <th>
                <span class="field-code">V362 json='transcriptedCaseNumber.county'</span> 
                <span id="V362">Destination County</span>
              </th>
              <th>
                <span class="field-code">V041 json='status#'</span> 
                <span id="V041">Transcript Status</span>
              </th>
              <th>
                <span class="field-code">V023 json='exemptIndicator#'</span> 
                <span id="V023">Exemption</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let transcript of civilCase.getTranscriptList(); let i = index">
              <td id="{{'civil-caseDetails-transcripts-' + i + '-typeOfServedDocumentForAbstracts'}}">
                {{transcript.getAbstractOrDocketInfo(civilCase)}}
              </td>
              <td id="{{'civil-caseDetails-transcripts-' + i + '-dateTime'}}">
                {{transcript.getDateTime() | date:'MM/dd/yyyy'}} {{transcript.getDateTime() | date:'hh:mm a'}}
              </td>
              <td id="{{'civil-caseDetails-transcripts-' + i + '-destinationCounty'}}">
                {{transcript.getDestinationCounty()}}
              </td>
              <td id="{{'civil-caseDetails-transcripts-' + i + '-status'}}">
                {{transcript.getStatus()}}
              </td>
              <td id="{{'civil-caseDetails-transcripts-' + i + '-exemption'}}">
                {{transcript.getExemption()}}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
   </div>
  </div>
</div>


// WEBPACK FOOTER //
// /home/jenkins/workspace/pipeline-ciprs-ui-final/project/src/app/case-view/civil/transcript/transcript.component.html